import { ROLES } from 'config/roles';
import DashboardShell from 'layouts/DashboardShell';

/** Admin dashboard chrome — DashboardShell scoped to the admin nav set. */
export default function AdminLayout() {
  return <DashboardShell role={ROLES.ADMIN} />;
}
